import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import InnerHTML from '@Components/InnerHTML';

import './TooltipContent.scss';

function TooltipContent({ header, onClose, children }) {
  return (
    <div className="heatmap-tooltip-content">
      <header className="heatmap-tooltip-content__header">
        <InnerHTML tag="h4" html={header} />
        <Button
          buttonConfig={{
            className: 'els-btn-modal-close',
            ariaLabel: 'Close dialog box',
            type: 'link',
            size: 'sm',
            e2eName: 'modal-close',
          }}
          iconConfig={{
            name: 'delete',
            size: 'tiny',
          }}
          onClick={onClose}
        />
      </header>
      {children}
    </div>
  );
}

TooltipContent.defaultProps = {
  onClose: () => {},
};

TooltipContent.propTypes = {
  header: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

export default TooltipContent;
